import Header from "../teamReports/header";
import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { withRouter } from "react-router";
import _ from "lodash";
import { connect } from "react-redux";
const NotSignedIn = (props) => {
  const noTeamParams = _.get(props, "gameReducer.gamesData.no_team");
  const startTrialLink = noTeamParams.trial_link.url;
  const hideTeamReports = false;
  return (
    <>
      <Header hideTeamReports={hideTeamReports} />
      <div className="no-team-wrapper">
        <h1 className="heading">{noTeamParams.text_1}</h1>
        <p className="heading">{noTeamParams.text_2}</p>
        <button
          className="free-btn"
          onClick={() => {
            window.open(`${startTrialLink}`, "_self");
          }}
        >
          Start Free Trial{" "}
        </button>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

export default compose(withRouter, connect(mapStateToProps))(NotSignedIn);
